import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { HotelSearchState } from "../types/search";

const initialState: HotelSearchState = {
  destination: {
    label: "",
    value: "",
    countryCode: "",
    country: "",
    isProperty:false,
    city:"",
    CITY_NAME:"",
    NAME_SMALL_CAPS:""
  },
  checkInDate: dayjs().startOf("day").toString(),
  checkOutDate: dayjs().startOf("day").add(1, "day").toString(),
  nights: 1,
  nationality: "SA",
  currency: "SAR",
  ratings: [],
  rooms: [{ adults: 1, children: [] }],
  serviceFee: {
    type: "A",
    value: 0,
  },
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchValues(state, action: PayloadAction<Partial<HotelSearchState>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setSearchValues } = searchSlice.actions;
export default searchSlice.reducer;
